export class SoakStyleDto {
    soakstyleId: number;
    soakstyle: string;
    isActive: boolean;
    createdAt:Date;
    createdUser: string;
    updatedAt: Date;
    updatedUser: string;
    versionFlag: number;

    constructor(soakstyleId: number, soakstyle: string, isActive: boolean,createdAt:Date, createdUser: string, updatedAt: Date,
        updatedUser: string, versionFlag: number) {
            this.soakstyleId= soakstyleId;
            this.soakstyle= soakstyle;
            this.isActive= isActive;
            this.createdAt=createdAt;
            this.createdUser= createdUser;
            this.updatedAt= updatedAt;
            this.updatedUser= updatedUser;
            this.versionFlag= versionFlag;
    }
}